import { RoleAssignmentUpdate } from '@/features/role-assignments/components/RoleAssignmentUpdate';

const RoleAssignmentUpdatePage = () => {
  return <RoleAssignmentUpdate />;
};

export default RoleAssignmentUpdatePage;
